import React, { memo, useState, useEffect } from "react";
import { Card, Row, Col, Button, Carousel } from "react-bootstrap";
import { FiRefreshCcw } from "react-icons/fi";
import { IconContext } from "react-icons";
import "../components/component.css";
import { TimelineServiceItem } from "./TimelineServiceItem";
import { CardPatientMobile } from "./CardPatientMobile";
import { useIntl } from "react-intl";
import medicalReport from "../assets/images/medicalReport.png";
import { GENERAL_STATUS_COSTANTS, EXAMS_STATUS_ID } from "../utils/jsCostants";
import { findUrgencyCodeDescriptionId } from "../utils/findUrgencyByCode";
import './carousel.css';
import useWindowSize from "../hooks/useWindowSize";

export const ListPatient = memo(({
  encounters,
  onClickUpdate,
}) => {

  const intl = useIntl();

  const [arrayEncountersCarousel, setArrayEncountersCarousel] = useState({ index: 0, length: encounters.length });

  useEffect(() => {
    if (arrayEncountersCarousel.length < encounters.length) {
      setArrayEncountersCarousel({ index: 0, length: encounters.length });
    }
  }, [arrayEncountersCarousel.length, encounters.length]);

  const handleSelect = (selectedIndex) => {
    setArrayEncountersCarousel({ index: selectedIndex, length: encounters.length });
  };

  // Conditional rendering for extra small devices (phones, 600px and down) and others
  const windowSize = useWindowSize();
  const isDeviceExtraSmall = windowSize === 'xs' || windowSize === 'sm';

  const renderEncounterServices = (encounter) => {
    const { code: { code }, services, period, generalStatus, dischargeDisplay } = encounter;

    // Requested services go at the end.
    const sortedServices = services.sort((serviceA, serviceB) => {
      if (serviceA.status === EXAMS_STATUS_ID.RICHIESTO && serviceB.status === EXAMS_STATUS_ID.RICHIESTO) {
        return 0;
      }
      if (serviceA.status === EXAMS_STATUS_ID.RICHIESTO) {
        return 1;
      }
      if (serviceB.status === EXAMS_STATUS_ID.RICHIESTO) {
        return -1;
      }
      return 0;
    });

    const acceptance = {};
    const newServizi = [acceptance, ...sortedServices];

    return newServizi.map((el, index) => (
      <TimelineServiceItem
        key={index}
        period={period}
        status={el.status}
        type={el.type}
        generalStatus={generalStatus}
        descriptionDischargeDisplay={dischargeDisplay}
        index={index}
        lengthServicesArray={newServizi.length}
        descriptionUrgency={Number.parseInt(code) !== -1 ? intl.formatMessage({ id: findUrgencyCodeDescriptionId(code) }) : ""}
        dischargeDisplayContainerClass={'container-discharge-display-web'}
      />
    ));
  };

  const renderDescriptionUrgency = encounter => {
    const { code: { code } } = encounter;
    if (Number.parseInt(code) === -1) {
      return null;
    }

    const description = intl.formatMessage({ id: findUrgencyCodeDescriptionId(code) });

    return (
      <>
        <Card.Text style={{ fontSize: "65%", display: 'inline' }}>
          {description}
        </Card.Text>
      </>
    );
  };

  const renderCardPatient = (encounter, index) => {
    return (
      <Row className=" justify-content-center" key={encounter.id}>
        <Col lg={10}>
          <Card style={{ borderRadius: "12pt", marginTop: '2rem' }} className="card-timeline border-card">
            <Card.Header style={{ marginBottom: "25px", marginTop: "0px", paddingBottom: "25px", background: "#fff" }}>
              <Card.Title style={{ fontSize: "75%" }} className="d-flex justify-content-between align-items-center">
                <b>
                  {intl.formatMessage({ id: 'monitoraggioPazientePage.labelPaziente' })}&nbsp;
                            {index + 1}
                </b>
                <span className='button-message' style={{ color: "#fff", background: "#092451", borderRadius: "3pt", padding: "5px", textTransform: "uppercase" }}>
                  {
                    (encounter.generalStatus === GENERAL_STATUS_COSTANTS.NOT_AVAILABLE || encounter.generalStatus === GENERAL_STATUS_COSTANTS.NOT_YET_AVAILABLE) ?
                      intl.formatMessage({ id: 'monitoraggioPazientePage.inElaborazione' })
                      :
                      encounter.generalStatusDisplay
                  }
                </span>
              </Card.Title>
              {renderDescriptionUrgency(encounter)}
            </Card.Header>
            <Card.Body style={{ padding: '0 1em' }}>
              <Row>
                <Col xs="12">
                  {renderEncounterServices(encounter)}
                </Col>
                <Col xs="12" className="text-right">
                  <Button
                    type="button"
                    className="text-uppercase px-3 py-1 rounded font-weight-bold d-inline-flex align-items-center"
                    variant="outline-danger"
                    onClick={() => onClickUpdate(encounter.id)}
                  >
                    <FiRefreshCcw
                      className="align-baseline mr-1"
                    />
                    {intl.formatMessage({ id: 'monitoraggioPazientePage.aggiornaPaziente' })}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  };

  function logoMedicalReport() {
    return (<img src={medicalReport} alt="medicalReport" />);
  }

  return (
    <React.Fragment>
      {encounters.length === 0 ?
        (
          <Card
            className="border-0 border-card mt-5 mt-md-4"
            style={{ minWidth: "min-content" }}
          >
            <Card.Title className="border-card">
              <Row className=" justify-content-center">
                <Col>
                  <Card
                    className="align-items-center border-0"
                    style={{
                      minWidth: "min-content",
                      marginBottom: "2rem"
                    }}
                  >
                    <IconContext.Provider
                      value={{
                        color: "gray",
                        className: "global-class-name"
                      }}
                    >
                      <div style={{
                        fontSize: "200%",
                      }}>
                        {logoMedicalReport()}
                      </div>
                    </IconContext.Provider>
                  </Card>
                </Col>
              </Row>
              <Row className="align-items-center justify-content-center">
                <Col md={4} className="align-items-center">
                  <div
                    className="text-center"
                    style={{
                      fontSize: "65%",
                      WebkitTextFillColor: "gray"
                    }}
                  >
                    {intl.formatMessage({ id: 'monitoraggioPazientePage.nessunCodiceContatto' })}
                  </div>
                </Col>
              </Row>
            </Card.Title>
            <Card.Text className="text-center">
              <span
                className="d-flex justify-content-center"
                style={{
                  fontSize: "60%",
                  WebkitTextFillColor: "gray"
                }}
              >
                {intl.formatMessage({ id: 'monitoraggioPazientePage.trovaloSuFoglioAccettazione' })}
              </span>
            </Card.Text>
          </Card>
        )
        : (
          <>
            <Row className="mt-4 justify-content-center">
              <Col lg={10}>
                <Card className="border-0">
                  <Card.Title style={{ marginBottom: "2.5%", fontSize: '100%' }}>
                    <b>{intl.formatMessage({ id: 'monitoraggioPazientePage.labelElencoPazienti' })}</b>
                  </Card.Title>
                </Card>
              </Col>
            </Row>
            {
              isDeviceExtraSmall ?
                (
                  <Carousel activeIndex={arrayEncountersCarousel.index} onSelect={handleSelect} indicators={true} interval={null}>
                    {
                      encounters.map((encounter, index) => (
                        <Carousel.Item key={index}>
                          <CardPatientMobile
                            key={index}
                            encounter={encounter}
                            onClickUpdate={onClickUpdate}
                            patientIndex={index}
                            activePatientCardIndex={arrayEncountersCarousel.length - arrayEncountersCarousel.index - 1}
                          />
                        </Carousel.Item>
                      )).reverse()
                    }
                  </Carousel>
                )
                :
                encounters.map((encounter, index) => (
                  renderCardPatient(encounter, index)
                )).reverse()
            }
          </>
        )}
      <Row style={{ marginBottom: "8rem" }} />
    </React.Fragment>
  );
});
